/*
	ExpensesSettings.tsx
    Une page affichant les réglages pour les dépenses
	Inclut un accès vers les pages CRUD des centres de coûts et de leurs catégories
*/

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faAngleLeft,
	faCube,
	faCubes,
	faPen,
	faReceipt,
} from '@fortawesome/free-solid-svg-icons';
import { MainButton } from '../common';
import PageHeader from 'layout/PageHeader';

// Composant proposant les deux liens vers les réglages des dépenses et un bouton de retour
const ExpensesSettings: React.FC = () => {
	// State management
	const navigate = useNavigate();

	// Rendu du composant
	return (
		<div className="min-h-screen bg-gray-100 p-6">
			{/* Barre de titre de la page */}
			<PageHeader
				icon={faReceipt}
				title="Réglages des dépenses"
				subtitle="Gérez les centres de coûts et leurs catégories"
				className="!max-w-3xl"
			/>

			{/* Card principale */}
			<div className="max-w-3xl mx-auto mt-6 bg-white rounded-lg shadow-md p-6">
				{/* Liste des réglages */}
				<div className="flex justify-center">
					<div className="grid grid-cols-[1fr_auto] items-center gap-x-6 gap-y-4">
						{/* Catégories de Centres de Coûts */}
						<div className="flex items-center gap-2">
							<FontAwesomeIcon icon={faCubes} />
							<span>Catégories de Centres de Coûts</span>
						</div>
						<MainButton
							label="Gérer"
							onClick={() => navigate('/app/settings/cost-center-categories')}
							size="sm"
							icon={faPen}
						/>

						{/* Centres de Coûts */}
						<div className="flex items-center gap-2">
							<FontAwesomeIcon icon={faCube} />
							<span>Centres de Coûts</span>
						</div>
						<MainButton
							label="Gérer"
							onClick={() => navigate('/app/settings/cost-centers')}
							size="sm"
							icon={faPen}
						/>
					</div>
				</div>

				{/* Bouton retour */}
				<div className="mt-6 flex justify-end">
					<button
						onClick={() => navigate('/app/settings#GPO')}
						className="flex items-center gap-2 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
					>
						<FontAwesomeIcon icon={faAngleLeft} />
						Retour
					</button>
				</div>
			</div>
		</div>
	);
};

// Export du composant
export default ExpensesSettings;
